import script from "./PageTitle.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageTitle.vue?vue&type=script&lang=ts&setup=true"

import "./PageTitle.vue?vue&type=style&index=0&id=f8a9a822&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8a9a822"]])

export default __exports__